import React from "react";
import { Delete, Pencil } from "lucide-react";

const DataTable = ({
  columns,
  data,
  currentPage,
  itemsPerPage,
  isLoading,
  onEdit,
  setEditItem,
  setShowDeleteModal,
  toggleDisplay
}) => {
  const renderHeader = () => (
    <thead className="bg-gray-50">
      <tr>
        {columns.map((col) => (
          <th key={col.key} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
  );

  const renderRows = () => (
    <tbody className="bg-white divide-y divide-gray-200">
      {data.map((item, index) => {
        const sno = index + 1 + (currentPage - 1) * itemsPerPage;
        const prompt = item.prompt?.length > 50
          ? item.prompt.slice(0, 50) + "..."
          : item.prompt || "-";
        const imageUrl = item.image;

        return (
          <tr key={item._id} className="hover:bg-gray-50">
            <td className="px-6 py-4 text-sm text-gray-700">{sno}</td>
            <td className="px-6 py-4 text-sm text-gray-700 max-w-xs break-words">{prompt}</td>
            <td className="px-6 py-4">
              {imageUrl ? (
                <img src={imageUrl} alt="img" className="w-12 h-12 object-cover rounded" />
              ) : (
                <span className="text-gray-400">No Image</span>
              )}
            </td>
            <td className="px-6 py-4">
              <div className="flex items-center whitespace-nowrap space-x-3">
                <button
                  onClick={() => toggleDisplay(item)}
                  className={`w-10 h-5 flex items-center rounded-full p-1 transition-colors duration-200 ${item.isDisplay ? 'bg-primary-600' : 'bg-gray-300'
                    }`}
                >
                  <div
                    className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-200 ${item.isDisplay ? 'translate-x-5' : 'translate-x-0'
                      }`}
                  />
                </button>
              </div>
            </td>

            <td className="px-6 py-4">
              <p className="flex items-center">
                {/* <button
                  onClick={() => onEdit(item)}
                  className="text-primary-600 hover:text-primary-800 text-sm flex items-center gap-1"
                >
                  <Pencil className="w-4 h-4" /> Edit
                </button> */}
                <button
                  onClick={() => { setEditItem(item); setShowDeleteModal(true); }}
                  className="text-red-600 hover:text-red-800 text-sm flex items-center gap-1 ml-2"
                >
                  <Delete className="w-4 h-4" /> Delete
                </button>
              </p>
            </td>
          </tr>
        );
      })}
    </tbody>
  );

  const renderEmpty = () => (
    <tbody>
      <tr>
        <td colSpan={columns.length} className="text-center px-6 py-10 text-gray-500">
          No inspirations found.
        </td>
      </tr>
    </tbody>
  );

  const renderLoading = () => (
    <tbody>
      {[...Array(3)].map((_, rowIndex) => (
        <tr key={rowIndex}>
          {columns.map((_, colIndex) => (
            <td key={colIndex} className="px-6 py-4">
              <div className="h-4 bg-gray-200 rounded animate-pulse" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        {renderHeader()}
        {isLoading ? renderLoading() : data.length > 0 ? renderRows() : renderEmpty()}
      </table>
    </div>
  );
};

export default DataTable;